import Contacts from 'components/ContactsComponents/Contacts';

const ContactsPage = () => {
  return <Contacts />;
};

export default ContactsPage;
